import TroubleshootIcon from "@mui/icons-material/Troubleshoot";

export const ProbeToolConfig = {
  name: "PROBE",
  tool: "Probe",
  icon: <TroubleshootIcon />,
};